// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"3136c435","787":"15ab848f","910":"4bf26366"}[chunkId] + ".chunk.js";
};